import * as types from '@/store/mutation-types';
import { searchParty } from '@/mixins/search-party';
import _ from 'lodash';

const mutations = {
  [types.SET_FOOTERNAV_LINK_TITLE](state, p) {
    let drp = p.drp;
    drp = searchParty.methods._goFind({
      entry: drp.links,
      value: p.id,
    }).found;
    drp.title = p.newTitle;
  },
  [types.SET_FOOTERNAV_LINK_HREF](state, p) {
    const drp = searchParty.methods._goFind({
      entry: p.drp.links,
      value: p.linkId,
    }).found;
    // since drops trigger the change event.
    if (drp && !_.isUndefined(p.link)) {
      drp.link = p.link;
    }
  },
  [types.SET_FOOTERNAV_LINK_WINDOW](state, p) {
    let drp = p.drp;
    drp = searchParty.methods._goFind({
      entry: drp.links,
      value: p.id,
    }).found;
    drp.newWindow = p.newWindow;
    drp.target = p.target;
  },
  [types.ADD_FOOTERNAV_LINK](state, p) {
    const drp = p.drp;
    drp.links.push(p.newLink);
  },
  [types.SET_FOOTER_NAV_ACTIVE_LINK](state, p) {
    const drp = p.drp;
    drp.activeLink = p.activeLink;
  },
  [types.REMOVE_FOOTERNAV_LINK](state, p) {
    const drp = p.drp;
    const links = drp.links;
    if (!_.isUndefined(p.parentId)) {
      const parent = searchParty.methods._goFind({
        entry: links,
        value: p.parentId,
      }).found;
      parent.subLinks.splice(p.index, 1);
    } else {
      links.splice(p.index, 1);
    }
  },
  [types.REARRANGE_FOOTERNAV_LINKS](state, p) {
    const drp = p.drp;
    const links = drp.links;
    const link = searchParty.methods._goFind({
      entry: links,
      value: p.linkId,
    }).found;
    let newParent = searchParty.methods._goFind({
      entry: links,
      value: p.newParentId,
    }).found;
    let oldParent = searchParty.methods._goFind({
      entry: links,
      value: p.oldParentId,
    }).found;
    if (!newParent) {
      newParent = links;
    } else {
      newParent = newParent.subLinks;
    }
    if (!oldParent) {
      oldParent = links;
    } else {
      oldParent = oldParent.subLinks;
    }
    if (newParent === oldParent) {
      newParent.splice(p.newIndex, 0,
        newParent.splice(p.oldIndex, 1)[0]);
    } else {
      // remove from old parent
      oldParent.splice(p.oldIndex, 1);
      // add to new parent
      newParent.splice(p.newIndex, 0, link);
    }
  },
};

const actions = {
  setFooterNavLinkTitle: ({ commit }, payload) => {
    commit(types.SET_FOOTERNAV_LINK_TITLE, payload);
  },
  setFooterNavLinkHref: ({ commit }, payload) => {
    commit(types.SET_FOOTERNAV_LINK_HREF, payload);
  },
  setFooterNavLinkWindow: ({ commit }, payload) => {
    payload.target = (payload.newWindow) ? '_blank' : '_self';
    commit(types.SET_FOOTERNAV_LINK_WINDOW, payload);
  },
  addFooterNavLink: ({ commit }, payload) => {
    commit(types.ADD_FOOTERNAV_LINK, payload);
  },
  removeFooterNavLink: ({ commit }, payload) => {
    commit(types.REMOVE_FOOTERNAV_LINK, payload);
  },
  rearrangeFooterNavLinks: ({ commit }, payload) => {
    commit(types.REARRANGE_FOOTERNAV_LINKS, payload);
  },
  setFooterNavActiveLink: ({ commit }, payload) => {
    commit(types.SET_FOOTER_NAV_ACTIVE_LINK, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/footer-nav/vuex.js